import React from 'react';
import Fleet from '../components/Fleet';

function FleetPage() {
  return (
    <div style={{ paddingTop: '100px' }}>
      {/* Page Header */}
      <section style={{ padding: '3rem 0', background: 'linear-gradient(135deg, #0A1A2F 0%, #1a3a5f 100%)', color: '#fff' }}>
        <div className="container text-center">
          <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem', fontFamily: 'Montserrat' }}>Our Fleet</h1>
          <p style={{ fontSize: '1.2rem', color: '#C9A44A' }}>Modern, Safe & Comfortable Vehicles</p>
        </div>
      </section>

      <Fleet />
      
      {/* Vehicle Features */}
      <section style={{ padding: '5rem 0', background: '#fff' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">All Vehicles Feature:</h2>
          </div>
          <div className="row">
            <div className="col-md-3 mb-4">
              <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '15px', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
                <h5 style={{ fontFamily: 'Montserrat', marginBottom: '0.5rem' }}>RTA Approved</h5>
                <p style={{ color: '#666', margin: 0 }}>Fully licensed and compliant</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '15px', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔧</div>
                <h5 style={{ fontFamily: 'Montserrat', marginBottom: '0.5rem' }}>Well Maintained</h5>
                <p style={{ color: '#666', margin: 0 }}>Regular servicing & checks</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '15px', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❄️</div>
                <h5 style={{ fontFamily: 'Montserrat', marginBottom: '0.5rem' }}>Air Conditioned</h5>
                <p style={{ color: '#666', margin: 0 }}>Comfortable in all weather</p>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div style={{ padding: '2rem', background: '#f8f9fa', borderRadius: '15px', textAlign: 'center' }}>
                <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🛡️</div>
                <h5 style={{ fontFamily: 'Montserrat', marginBottom: '0.5rem' }}>Full Insurance</h5>
                <p style={{ color: '#666', margin: 0 }}>Comprehensive coverage</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FleetPage;